import {
  Box,
  Dialog, DialogContent, useTheme,
} from '@mui/material';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { useState } from 'react';
import { camelCase, kebabCase } from 'change-case';
import { useTranslation } from 'react-i18next';
import { UnlinkPartnerCard } from '../Enrollment/UnlinkPartnerCard';
import { getCanonicalPartnerName } from '../../../../common/constants';

type UnenrollmentDialogProps = {
  updateDialogOpenState: (event: boolean) => void;
  partnerName: string,
  partnerId: string,
  partnerCode?: string,
};

export function UnenrollmentDialog({
  updateDialogOpenState,
  partnerName,
  partnerId,
  partnerCode,
}: UnenrollmentDialogProps) {
  const theme = useTheme();
  const { t } = useTranslation();

  // Rename-stable name for deriving i18n keys / a11y ids (see getCanonicalPartnerName).
  const partnerKeyName = getCanonicalPartnerName(partnerCode, partnerName);
  const [localEnrollmentDialogOpenState, updateLocalEnrollmentDialogOpenState] = useState(true);
  const onDialogClose = () => {
    // reset all to default states
    updateLocalEnrollmentDialogOpenState(false);
    updateDialogOpenState(false);
  };

  return (
    <>
      <Dialog
        open={localEnrollmentDialogOpenState}
        keepMounted
        onClose={onDialogClose}
        aria-describedby={`${kebabCase(partnerKeyName)}-enrollment-dialog`}
        sx={{
          '& .MuiDialog-paper': {
            width: '100%',
            borderRadius: theme.spacing(2.25),
            [theme.breakpoints.down('lg')]: {
              p: theme.spacing(0),
            },
          },
        }}
      >
        <DialogContent
          sx={{ paddingRight: theme.spacing(3) }}
        >
          <IconButton
            aria-label="close"
            onClick={onDialogClose}
            sx={{
              position: 'absolute',
              right: theme.spacing(1),
              top: theme.spacing(1),
              color: theme.palette.brand.primary,
            }}
          >
            <CloseIcon />
          </IconButton>
          <Box>
            <UnlinkPartnerCard
              partnerId={partnerId}
              partnerName={partnerName}
              partnerCode={partnerCode}
              title={t(`${camelCase(partnerKeyName)}.unlinkDialogConfirmation.title`)}
              description={t(`${camelCase(partnerKeyName)}.unlinkDialogConfirmation.description`)}
              setOpenUnlink={updateDialogOpenState}
            />
          </Box>
        </DialogContent>
      </Dialog >
    </>
  );
}
